// The ten-minute "taking longer than expected" / "offers Regenerate again" threshold
// (`NFR-2`, `components/search-term.md § What the SPA owns, and what it must not invent`).
// One home for this constant: `SearchTermsContentV2.tsx` and `SearchTermsProductCard.tsx`
// import it for their existing `isStaleSet` helpers (which keep reading `created_at`), and
// `SearchTermSetCard/index.tsx` imports it for the regeneration `isStale` derivation (which
// reads `regeneration_started_at`). Those are two different predicates sharing one value —
// this module holds only the value.
export const STALE_THRESHOLD_MS = 10 * 60 * 1000;
